<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Bookings & Actuals</span><br/>
      <span style="font-style: italic; font-size: 18px">view bookings by date range, click + for details, click Download for a CSV with these results</span>
    </div>

    <div v-if="!this.$route.query.booking_id" style="font-size: 18px; font-weight: bold; position: relative; margin: 20px 0px 20px 0px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;<b-form-select v-model="actuals_filter" :options="actuals_filter_options" style="font-size: 18px; font-weight: bold; width:190px"/>
      <span v-if="company_options">
        &nbsp;&nbsp;&nbsp;<b-form-select v-model="selected_company" :options="company_options" style="font-size: 18px; font-weight: bold; width:180px"/>
      </span>
      <span v-if="type_options">
      &nbsp;&nbsp;<b-form-select v-model="selected_type" :options="type_options" style="font-size: 18px; font-weight: bold; width:150px"/>
      </span>
      &nbsp;&nbsp;<b-button v-on:click.prevent="search_by_date_range()">></b-button>
      &nbsp;&nbsp;<b-form-input style="width: 165px" v-model="booking_search" placeholder="search by charterID"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="search_by_id()">></b-button>
      &nbsp;&nbsp;Filter&nbsp;<b-form-input style="width: 150px" v-model="booking_filter" placeholder="filter"/>
      <span v-if="vehicle_options">
        &nbsp;&nbsp;&nbsp;<b-form-select v-model="selected_vehicle" :options="vehicle_options" style="font-size: 18px; font-weight: bold; width:140px"/>
      </span>
      <span v-if="base_options && base_options.length > 2">
        &nbsp;&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="font-size: 18px; font-weight: bold; width:150px"/>
      </span>
      &nbsp;&nbsp;<b-button variant="success" size="md" @click="download">Download</b-button>
    </div>

    <div v-if="!this.$route.query.booking_id && !loading" style="margin: 20px;">
      <div v-if="summary.actuals_request_timestamp"><b>actuals last requested in CM for {{details_toDate}} at {{ summary.actuals_request_timestamp | formatDateTimeCustom(summary.datetime_format)}}</b></div>
      <div class="row" style="margin: 10px; font-weight: bold; font-size: 24px;">
        <div @click="filter_by_status(null)" class="col" style="border: 1px solid grey;">{{ items.length }} of {{items_full.length}}</div>
        <div @click="filter_by_status('success')" class="col success" style="border: 1px solid grey;">Succeeded: {{success_cnt}}</div>
        <div @click="filter_by_status('error')" class="col error" style="border: 1px solid grey;">Errored: {{error_cnt}}</div>
        <div @click="filter_by_status('cancelled')" class="col cancelled" style="border: 1px solid grey;">Cancelled: {{cancelled_cnt}}</div>
        <div @click="filter_by_status('unprocessed')" class="col unprocessed" style="border: 1px solid grey;">Unprocessed: {{unprocessed_cnt}}</div>
        <div style="border: 1px solid white;margin:3px"><b-button v-on:click.prevent="reprocess_actuals()">Reprocess Actuals</b-button></div>
      </div>
    </div>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :tbody-tr-class="get_row_color"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="status_msg" slot-scope="row">
          <div style="text-align: left" v-for="msg in row.item.status_msg.split(',')">
            <span v-html="msg"/>
          </div>
        </template>

        <template slot="notes" slot-scope="row">
          <b-form-input style="width:250px" v-model="row.item.notes" v-on:blur="save_notes(row.item)" @keydown.enter.native="save_notes(row.item)"/>
        </template>

        <template slot="reprocess" slot-scope="row">
          <span v-if="enable_reprocess" size="sm" @click="reprocess_alert(row.item)"><span style="font-size: 35px;">&#8635;</span></span>
        </template>

        <template slot="last_updated" slot-scope="row">
          {{row.item.last_updated | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="start_datetime" slot-scope="row">
          {{row.item.start_datetime | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="driver" slot-scope="row">
            {{row.item.driver | trim(20)}}
        </template>

        <template slot="pickup" slot-scope="row">
            {{row.item.pickup | trim(15)}}
        </template>

        <template slot="routeName" slot-scope="row">
          {{row.item.routeName | trim(30)}}
        </template>

        <template slot="finish_datetime" slot-scope="row">
          {{row.item.finish_datetime | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="delete" slot-scope="row">
          <div style="font-weight: bold; color: darkred; padding:3px">
            &nbsp;<a @click="delete_item(row.item)">X</a>&nbsp;
          </div>
        </template>

        <template slot="details" slot-scope="row">
          <div style="align-content: center">
            <b-button size="sm" @click="row.toggleDetails">
              {{ row.detailsShowing ? '-' : '+' }}
            </b-button>&nbsp;
          </div>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card style="text-align: left; border: 1px solid grey">
            <table width="100%">
              <tr>
                <th>Event</th>
                <th>Planned Time</th>
                <th>HOS Time</th>
                <th>HOS Delta</th>
                <th>Vehicle Actual Time</th>
                <th>Vehicle Delta</th>
                <th>Planned Location</th>
              </tr>
              <tr>
                <td>Start Time</td>
                <td>{{row.item.actual.movement.StartDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{row.item.actual.nearestLoginStartDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{get_time_diff(row.item.actual.plannedStartDateTime,row.item.actual.nearestLoginStartDateTime)}}</td>
                <td>{{row.item.actual.nearestLocationStartDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{get_time_diff(row.item.actual.plannedStartDateTime,row.item.actual.nearestLocationStartDateTime)}}</td>
                <td><span v-html="row.item.actual.startMapLink"/></td>
              </tr>
              <tr>
                <td>Position/Spot</td>
                <td>{{row.item.actual.movement.PositionDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>{{row.item.actual.actualPositionDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{get_time_diff(row.item.actual.plannedPositionDateTime,row.item.actual.actualPositionDateTime)}}</td>
                <td><span v-html="row.item.actual.positionMapLink"/></td>
              </tr>
              <tr>
                <td>Pickup Time</td>
                <td>{{row.item.actual.movement.PickupDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>{{row.item.actual.actualPickupDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{get_time_diff(row.item.actual.plannedPickupDateTime,row.item.actual.actualPickupDateTime)}}</td>
                <td><span v-html="row.item.actual.pickupMapLink"/></td>
              </tr>
              <tr>
                <td>Arrival Time</td>
                <td>{{row.item.actual.movement.ArrivalDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>{{row.item.actual.actualArrivalDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{get_time_diff(row.item.actual.plannedArrivalDateTime,row.item.actual.actualArrivalDateTime)}}</td>
                <td><span v-html="row.item.actual.arrivalMapLink"/></td>
              </tr>
              <tr>
                <td>Leave Time</td>
                <td>{{row.item.actual.movement.LeaveDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>{{row.item.actual.actualLeaveDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{get_time_diff(row.item.actual.plannedLeaveDateTime,row.item.actual.actualLeaveDateTime)}}</td>
                <td><span v-html="row.item.actual.leaveMapLink"/></td>
              </tr>
              <tr>
                <td>Back Time</td>
                <td>{{row.item.actual.movement.BackDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>{{row.item.actual.actualBackDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{get_time_diff(row.item.actual.plannedBackDateTime,row.item.actual.actualBackDateTime)}}</td>
                <td><span v-html="row.item.actual.backMapLink"/></td>
              </tr>
              <tr>
                <td>Finish Time</td>
                <td>{{row.item.actual.movement.FinishDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{row.item.actual.nearestLogoutFinishDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{get_time_diff(row.item.actual.plannedFinishDateTime,row.item.actual.nearestLogoutFinishDateTime)}}</td>
                <td>{{row.item.actual.nearestLocationFinishDateTime | formatDateTimeCustom(summary.datetime_format)}}</td>
                <td>{{get_time_diff(row.item.actual.plannedFinishDateTime,row.item.actual.nearestLocationFinishDateTime)}}</td>
                <td><span v-html="row.item.actual.finishMapLink"/></td>
              </tr>
            </table>
            <br/>
            <div v-html="row.item.actual.samsara_links"/>
            <span>
              <b>Map Links: </b>
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/vehicle-track/' + user.tenant + '/' + row.item.vehicle }">Track Vehicle</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/bookingType/' + row.item.bookingType }">Track '{{row.item.bookingType}}' Vehicles</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/clientID/' + row.item.clientID }">Track '{{row.item.clientID}}' Vehicles</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/pickup/' + row.item.pickup }">Track '{{row.item.pickup}}' Pickup</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/booking/' + row.item.charterID }">Track Booking '{{row.item.charterID}}' Vehicles</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/movement/' + row.item.bookingID }">Track Movement '{{row.item.movementID}}' Vehicles</router-link>
              &nbsp;|&nbsp;
              <router-link style="font-weight: bold;" :to="{ path: '/vehicle_trip_history?vehicleId=' + row.item.vehicle }">Trip History</router-link>
            </span>

            <div class="row" style="margin: 10px 0px 0px 10px">
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.source_actualStartDateTime">
                <div><b>Calc Event Source:</b></div>
                <div>Start Time: {{row.item.actual.source_actualStartDateTime | nearest }}</div>
                <div>Finish Time: {{row.item.actual.source_actualFinishDateTime | nearest }}</div>
              </span>

              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.nearestLoginStartDateTime || row.item.actual.nearestEngineOnStartDateTime || row.item.actual.nearestLocationStartDateTime">
                <b>Start Event Times:</b><br/>
                HOS On Duty: {{row.item.actual.nearestLoginStartDateTime | formatDateTimeCustom(summary.datetime_format)}}<br/>
                DVIR Pre Trip Time: {{row.item.actual.nearestPreTripDVIRDateTime | formatDateTimeCustom(summary.datetime_format)}}<br/>
                Vehicle Key On: {{row.item.actual.nearestEngineOnStartDateTime | formatDateTimeCustom(summary.datetime_format)}}<br/>
                Vehicle Start Leave: {{row.item.actual.nearestLocationStartDateTime | formatDateTimeCustom(summary.datetime_format)}}
              </span>
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.nearestLogoutFinishDateTime || row.item.actual.nearestEngineOffFinishDateTime || row.item.actual.nearestLocationFinishDateTime">
                <b>Finish Event Times:</b><br/>
                HOS Off Duty: {{row.item.actual.nearestLogoutFinishDateTime | formatDateTimeCustom(summary.datetime_format)}}<br/>
                DVIR Post Trip Time: {{row.item.actual.nearestPostTripDVIRDateTime | formatDateTimeCustom(summary.datetime_format)}}<br/>
                Vehicle Key Off: {{row.item.actual.nearestEngineOffFinishDateTime | formatDateTimeCustom(summary.datetime_format)}}<br/>
                Vehicle Finish Arrival: {{row.item.actual.nearestLocationFinishDateTime | formatDateTimeCustom(summary.datetime_format)}}
              </span>
            </div>
            <div class="row" style="margin: 10px 0px 0px 10px">
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.actualTotalDistance">
                <b>Distances (miles)</b><br/>
                Planned Total: {{row.item.plannedDistance}}<br/>
                Trip Total: {{row.item.actual.actualTotalDistance}}<br/>
                Start Odometer: {{row.item.actual.actualStartOdometer}}<br/>
                End Odometer: {{row.item.actual.actualEndOdometer}}<br/>
                Odometer Total: {{row.item.actual.actualEndOdometer - row.item.actual.actualStartOdometer}}
              </span>
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.jurisdictionDistances">
                <b>State Distances (miles)</b><br/>
                <div v-for="dist in row.item.actual.jurisdictionDistances">
                  {{dist.jurisdiction}} : {{dist.distance}}m
                </div>
              </span>
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.actualLiveDistance">
                <b>Live & Dead Mileage (miles):</b><br/>
                Live Mileage: {{row.item.actual.actualLiveDistance}}<br/>
                Dead Mileage: {{row.item.actual.actualEmptyDistance}}{{row.item.actual.actualDeadDistance}}<br/>
              </span>
              <span style="padding: 10px; border: 1px solid black" v-if="row.item.actual.actualHOSOnDuration">
                <b>Driver HOS Activity (minutes):</b><br/>
                Total On Duty: {{row.item.actual.actualHOSOnDuration}}<br/>
                Total Off Duty: {{row.item.actual.actualHOSOffDuration}}<br/>
                Total Driving : {{row.item.actual.actualHOSDrivingDuration}}<br/>
              </span>
            </div>
            <span v-if="row.item.actual.file_history">
              <br/>
              <div v-if="row.item.actual.file_history" style="text-align: left; margin-left: 10px">
                <button @click="toggle_div(row.item.actual,'isFileHistoryVisible')">show booking file history</button>
                <br/><br/>
                <div v-if="row.item.actual.isFileHistoryVisible">
                  <div class="row" v-for="file_history in row.item.actual.file_history.split(',')">
                    <div class="col">{{file_history.split(' : ')[1] | formatDateTimeCustom(summary.datetime_format)}}</div>
                    <div class="col">{{file_history.split(' : ')[0]}}</div>
                    <div class="col">                                                           
                      <a target='_blank' :href="'https://api.fleet-integrations.com/bookings/showBooking?tenant=' + user.tenant + '&bookingID=' + row.item.bookingID + '&filename=' + file_history.split(' : ')[0].replace(' ','')">show booking</a>
                      &nbsp;|&nbsp;<a target='_blank' :href="'https://api.fleet-integrations.com/bookings/downloadBooking?tenant=' + user.tenant + '&filename=' + file_history.split(' : ')[0].replace(' ','')">download file</a>
                      <span v-if="row.item.actual.file_history.includes(',')">&nbsp;|&nbsp;<a target='_blank' :href="'https://api.fleet-integrations.com/bookings/showDiff?tenant=' + user.tenant + '&bookingID=' + row.item.bookingID + '&filename=' + file_history.split(' : ')[0].replace(' ','') + '&history=' + row.item.actual.file_history">show diff</a></span>
                    </div>
                  </div>
                  <br/>
                </div>
              </div>
            </span>

            <div v-if="row.item.actual.mvmt_html" style="text-align: left; margin-left: 10px">
              <button @click="toggle_div(row.item.actual,'isMvmtVisible')">show CM movement</button>
              <br/><br/>
              <div v-html="row.item.actual.mvmt_html" :style="row.item.actual.isMvmtVisible ? '' : 'display:none'"/>
            </div>
          </b-card>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

    import {api_url, delete_booking, get_actuals, save_booking_notes, reprocess_actuals, reprocess_alerts_for_booking } from '../networking/apis'
    import {mapState} from "vuex";
    import moment from 'moment'
    import {justDate} from "@/helpers/dates";
    import axios from 'axios';

    export default {
      name: 'actuals',
      components: {
      },

      data() {
        return {
          msg: 'actuals',
          items: [],
          items_full: [],
          selected_status: null,
          summary: [],
          loading: true,
          company_options: null,
          vehicle_options: null,
          type_options: null,
          base_options: [],
          selected_vehicle: '',
          selected_company: '',
          selected_base: '',
          selected_type: '',
          details_fromDate: justDate(moment()),
          details_toDate: justDate(moment()),
          totalRows: 1,
          currentPage: 1,
          perPage: 100,
          pages: [],
          actuals_filter: 'finish',
          booking_filter: '',
          booking_search: '',
          actuals_filter_options: [
            { value: 'finish', text: 'By Finish Date' },
            { value: 'start', text: 'By Start Date' },
            { value: 'overlap', text: 'Overlaps Range' },
          ],
          fields: [
            { key: 'delete', label: '', sortable: false},
            { key: 'details', label: '', sortable: false},
            { key: 'bookingID', sortable: true},
            { key: 'charterID', label: 'CharterID', sortable: true},
            { key: 'movementID', label:'MvmtID', sortable: true},
            { key: 'vehicle', label:'Vehicle', sortable: true},
            { key: 'driver', sortable: true, label: 'Driver'},
            { key: 'bookingType', label: 'Type', sortable: true},
            { key: 'bookingBase', label: 'Base', sortable: true},
            { key: 'startBase', label: 'Start', sortable: true},
            { key: 'finishBase', label: 'Finish', sortable: true},
            { key: 'pickup', label: 'Pickup', sortable: true},
            { key: 'destination', label: 'Destination', sortable: true},
            //{ key: 'furtherRequirements', label: 'Further Reqs', sortable: true},
            //{ key: 'pickupInstructions', label: 'Pickup Inst', sortable: true},
            { key: 'companyID', label: 'Company', sortable: true},
            { key: 'clientID', label: 'ClientID', sortable: true},
            { key: 'routeName', sortable: true},
            //{ key: 'seats', sortable: true},
            { key: 'start_datetime', label:'Start', sortable: true},
            { key: 'finish_datetime', label: 'Finish', sortable: true},
            { key: 'last_updated', label:'CM Update', sortable: true},
            //{ key: 'processed_time', label:'Last Processed', sortable: true},
            //{ key: 'coach_manager_utc_day', label:'Start Date', sortable: true},
            //{ key: 'coach_manager_utc_finish_day', label:'Finish Date', sortable: true},
            //{ key: 'poc', sortable: true, thStyle: { width: "130px" }},
            { key: 'status_msg', label: 'Status Message', sortable: true, thStyle: { width: "450px" }},
            { key: 'notes', label: 'Notes', sortable: true, thStyle: { width: "250px" }},
            { key: 'reprocess', label: '', sortable: false, thStyle: { width: "20px" }},
          ],
          enable_reprocess: false
          ,
          options: {
            format: 'MM-DD-YYYY',
            useCurrent: true,
            minDate: moment().subtract(720, 'days'),
            maxDate: moment().add(180, 'days'),
            keepOpen: false,
            showClear: true,
            showClose: true,
            toolbarPlacement: 'top',
          },

        }
      },

      async created() {
        this.fields_all = this.fields
        this.check_features()
      },
      methods: {
        async check_features() {
          this.check_cols()
          this.load_data()
        },
        async check_cols() {
          this.delete_enabled = this.user.role == 'admin' || this.user.role == 'customer-admin'
          this.fields = this.fields_all
          if (!this.delete_enabled)
            this.fields = this.fields.filter(item => item.key != 'delete')
          if (this.user.role != 'admin')
            this.fields = this.fields.filter(item => item.key != 'bookingID' && item.key != 'poc')
          if (!this.user.features[this.user.tenant].booking_notes_enabled)
            this.fields = this.fields.filter(item => item.key != 'notes')
        },
        async reprocess_actuals() {
          try {
            if (confirm("are you sure you want to reprocess actuals for this date range and status?")) {
                this.$emit('showAlert', 'sending request to reprocess actuals', 'info', 5000)
                const {value: {data = []}} = await reprocess_actuals(this.user.tenant, this.actuals_filter, this.selected_company, this.selected_type, this.selected_status, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
                this.$emit('showAlert', 'reprocess request sent successfully', 'success', 5000)
              }
          } catch(e) {
            this.$emit('showAlert', 'error reprocessing actuals, try a smaller date range or contact support if needed', 'danger', 5000)
          }
        },
        async search_by_date_range() {
          this.booking_search = ''
          this.load_data()
        },
        async search_by_id() {
          this.booking_filter = ''
          this.load_data()
        },
        delete_item(delete_item) {
          if(confirm("Do you really want to delete booking: " + delete_item.bookingID + "?")) {
            delete_booking(this.user.tenant, delete_item.bookingID)
            this.load_data()
          }
        },
        async save_notes(item) {
          try {
            let json = {
              'booking_hash': item.bookingID,
              'type': 'actuals',
              'notes': item.notes
            }
            const {value: { data = [] } } = await save_booking_notes(this.user.tenant, json)
          } catch(e) {
            this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
          }

        },
        async load_data() {
          this.loading = true
          try {
            if (this.$route.query.booking_id)
              this.booking_search = this.$route.query.booking_id

            try {
              const {value: {data = []}} = await get_actuals(this.user.tenant, this.actuals_filter, this.booking_search, this.selected_company, this.selected_type, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
              this.summary = data.summary
              moment.tz.setDefault(this.summary.timezone)
              this.items = data.results
              this.items_full = data.results

              if (data.summary.companies && data.summary.companies.length > 2)
                this.company_options = data.summary.companies

              this.vehicle_options = data.summary.vehicles
              this.type_options = data.summary.types
              this.base_options = data.summary.bases
              this.filter_results()

              if (this.summary.total_cnt != this.items_full.length) {
                this.$emit('showAlert', 'too many results to process for ' + this.booking_search + ', showing partial results', 'warning', 10000)
              }

              if (this.user.tenant.includes('aaahi')) {
                this.enable_reprocess = true
              } else {
                this.enable_reprocess = false
              }
            } catch(e){
              this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
            }
          } catch(e){
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
          }
          this.loading = false
        },
        async reprocess_alert(item) {
          if (confirm("Are you sure you want to resend customer pre-trip notifications for this booking?")) {
            reprocess_alerts_for_booking(this.user.tenant, "CustomerTripNotification", item.bookingID)
            this.$emit('showAlert', 'reprocessing alert', 'info', 5000)
          }
        },
        async download(){
          this.$emit('showAlert', 'processing download request', 'info', 10000)
          axios.defaults.headers.common.Accept = {}
          axios.post(
              `${api_url}bookings/actuals/download`,
              {
                tenant: this.user.tenant,
                filter: this.actuals_filter,
                company: this.selected_company,
                type: this.selected_type,
                status: this.selected_status,
                fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
                toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
              }, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                  Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'blob'
              }
          ).then((response) => {
            axios.defaults.headers.common.Accept = 'application/json'
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                `actuals-${this.user.tenant}-${this.details_fromDate}-${this.details_toDate}.csv`
            )
            document.body.appendChild(link)
            link.click()
            this.$emit('showAlert', 'download complete', 'success', 5000)
          }).catch(e => {
            axios.defaults.headers.common.Accept = 'application/json'
            this.$emit('showAlert', 'actuals data could not be downloaded.', 'danger')
          })
        },
        async shift_detail_graph_date(shift) {
          this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
          this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
          this.booking_id_filter = ''
        },
        get_time_diff(time1, time2) {
          if (time1 != null && time2 != null)
            return Math.round((new Date(time2) - new Date(time1)) / (1000 * 60)) + 'm';
          return ''
        },
        toggle_div(item,field) {
          item[field] = !item[field];
          this.$forceUpdate();
        },
        get_row_color(item, type) {
            if (!item || type !== 'row') return
            return item.status
        },
        filter_by_status(status) {
          if (status == null || this.selected_status == status) {
            this.selected_status = null
          } else {
            this.selected_status = status
          }
          this.filter_results()
        },
        filter_results() {
          this.items = this.items_full
          if (this.booking_filter) {
            const val = this.booking_filter

            if (this.booking_filter.indexOf("=") != -1) {
              const field = this.booking_filter.split("=")[0]
              const value = this.booking_filter.split("=")[1]
              if (field == 'driver')
                this.items = this.items.filter(item => item.driver == value)
              else if (field == 'vehicle')
                this.items = this.items.filter(item => item.vehicle ==value)
            }
            else {
              this.items = this.items.filter(item => (this.contains(item.bookingID, val) ||
                  this.contains(item.status_msg, val) ||
                  this.contains(item.driver, val) ||
                  this.contains(item.vehicle, val) ||
                  this.contains(item.routeName, val) ||
                  this.contains(item.pickup, val) ||
                  this.contains(item.destination, val) ||
                  this.contains(item.bookingBase, val) ||
                  this.contains(item.startBase, val) ||
                  this.contains(item.finishBase, val) ||
                  this.contains(item.bookingType, val) ||
                  this.contains(item.fileHistory, val) ||
                  this.contains(item.clientID, val)));
            }
          }

          if (this.selected_status) {
            this.items = this.items.filter(item => item.status == this.selected_status)
          }
          if (this.selected_company) {
            this.items = this.items.filter(item => this.contains(item.companyID,this.selected_company))
          }
          if (this.selected_vehicle) {
            this.items = this.items.filter(item => this.contains(item.vehicle,this.selected_vehicle))
          }
          if (this.selected_base) {
            this.items = this.items.filter(item => this.contains(item.bookingBase,this.selected_base) || this.contains(item.startBase,this.selected_base) || this.contains(item.finishBase,this.selected_base))
          }
        },
        contains(val1, val2) {
          if (val1 != null) {
            return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
          }
          return false;
        }
      },
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
        success_cnt() {
          return this.items_full.filter(item => item.status == 'success').length
        },
        error_cnt() {
          return this.items_full.filter(item => item.status == 'error').length
        },
        cancelled_cnt() {
          return this.items_full.filter(item => item.status == 'cancelled').length
        },
        unprocessed_cnt() {
          return this.items_full.filter(item => item.status == 'unprocessed').length
        },
      },
      watch: {
        user: {
          deep: true,
          handler() {
            this.load_data()
          }
        },
        booking_filter() {
          this.filter_results()
        },
        selected_base() {
          this.filter_results()
        },
        selected_vehicle() {
          this.filter_results()
        },
      }
    }
</script>

<style>

.error { background-color: rgba(255,0,0,0.25)}
.success { background-color: hsla(120,100%,75%,0.3)}
.unprocessed { background-color: hsla(200,40%,80%,0.3) }
.cancelled { background-color: hsla(290,60%,70%,0.3) }

.error td { background-color: rgba(255,0,0,0.25)}
.success td {background-color: hsla(120,100%,75%,0.3)}
.unprocessed td { background-color: hsla(200,40%,80%,0.3) }
.cancelled td { background-color: hsla(290,60%,70%,0.3) }


div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

</style>

